// extracted by mini-css-extract-plugin
export default {"innerButton":"InputClear_innerButton__RiD7g","input":"InputClear_input__dvAas","searchButton":"InputClear_searchButton__YaVFv"};